// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price__details-2et6S";
var _3 = "price__group-2BdWZ";
var _4 = "price__separator-2GpHa";
var _5 = "price__label-3M7HN";
var _6 = "price__item-IVbTz";
var _7 = "price__item_highlighted-3BplR";
export { _1 as "__esModule", _2 as "price__details", _3 as "price__group", _4 as "price__separator", _5 as "price__label", _6 as "price__item", _7 as "price__item_highlighted" }
export default { "__esModule": _1, "price__details": _2, "price__group": _3, "price__separator": _4, "price__label": _5, "price__item": _6, "price__item_highlighted": _7 }
